import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {TranslateService} from '@ngx-translate/core';
import {Report} from './report.model';
import {ReportService} from './report.service';

@Component({
  selector: 'app-report-form',
  templateUrl: './report-form.component.html'
})
export class ReportFormComponent extends FormComponent implements OnInit {

  public report: Report = new Report();
  public formTitle: string;
  public stateIdParam: string = 'reportId';

  constructor(
    protected router: UIRouter,
    private reportService: ReportService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('report.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.reportService.get(this.router.stateService.params[this.stateIdParam]).subscribe((report) => {
          this.report = report;
        });

        this.translate.get('report.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;
    }
  }

  public fileChange(evt) {
    this.report.setFile(evt.target.files);
  }

  public save(): void {
    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.reportService.add(this.report).subscribe((result) => {
          this.router.stateService.go('management.report', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.reportService.update(this.report).subscribe((result) => {
          this.router.stateService.go('management.report', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report-form.component.ts